import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

const MESES = ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

export default function CobrosPage() {
  const { cid } = useParams();
  const [periodos, setPeriodos] = useState([]);
  const [periodoId, setPeriodoId] = useState('');
  const [vencimiento, setVencimiento] = useState('');
  const [simulacion, setSimulacion] = useState(null);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  const loadPeriodos = () => {
    api
      .get(`/gastos-comunes/condominios/${cid}/periodos`)
      .then((r) => {
        setPeriodos(r.data);
        if (!periodoId && r.data.length) setPeriodoId(r.data[0].id);
      })
      .catch((e) => setError(e.response?.data?.error || e.message));
  };

  useEffect(() => {
    if (cid) {
      localStorage.setItem('gc_condominio_id', cid);
      loadPeriodos();
    }
  }, [cid]);

  const periodoSel = periodos.find((p) => p.id === periodoId);

  const simular = async () => {
    setError('');
    setMsg('');
    setSimulacion(null);
    try {
      const body = vencimiento ? { vencimiento } : {};
      const { data } = await api.post(
        `/gastos-comunes/condominios/${cid}/periodos/${periodoId}/simular-cargos`,
        body
      );
      setSimulacion(data);
      setMsg(`Simulación: ${data.cargos.length} cargos, total ${clp(data.total)}.`);
      loadPeriodos();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const publicar = async () => {
    if (!window.confirm('¿Publicar cargos en borrador? Generará deuda en cada departamento.')) return;
    setError('');
    setMsg('');
    try {
      const { data } = await api.post(`/gastos-comunes/condominios/${cid}/periodos/${periodoId}/publicar`);
      setMsg(`Publicados ${data.cantidad ?? 'OK'} cargos, total ${clp(data.total)}.`);
      setSimulacion(null);
      loadPeriodos();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const cerrar = async () => {
    if (!window.confirm('¿Cerrar el período? No se podrán modificar cargos del mes.')) return;
    setError('');
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/periodos/${periodoId}/cerrar`);
      setMsg('Período cerrado.');
      loadPeriodos();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <div className="page-header">
        <h2>Cobros mensuales</h2>
        <p>Simular cargos desde tarifas/cuotas, publicar al padrón y cerrar el mes.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="card">
        <div className="form-row">
          <div className="field">
            <label>Período</label>
            <select value={periodoId} onChange={(e) => setPeriodoId(e.target.value)}>
              {periodos.map((p) => (
                <option key={p.id} value={p.id}>
                  {MESES[p.mes]} {p.anio} — {p.estado}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>Vencimiento (opcional)</label>
            <input type="date" value={vencimiento} onChange={(e) => setVencimiento(e.target.value)} />
          </div>
        </div>
        <div className="form-row">
          <button type="button" className="btn" onClick={simular} disabled={!periodoId || periodoSel?.estado === 'cerrado'}>
            Simular cargos
          </button>
          <button type="button" className="btn secondary" onClick={publicar} disabled={!periodoId || periodoSel?.estado === 'cerrado'}>
            Publicar
          </button>
          <button type="button" className="btn secondary" onClick={cerrar} disabled={!periodoId || periodoSel?.estado === 'cerrado'}>
            Cerrar período
          </button>
        </div>
      </div>

      {simulacion?.cargos?.length > 0 && (
        <div className="card">
          <h3 className="card-title">Vista previa</h3>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Depto</th>
                  <th>Importe</th>
                </tr>
              </thead>
              <tbody>
                {simulacion.cargos.map((c) => (
                  <tr key={c.id}>
                    <td>{c.codigoDepto}</td>
                    <td>{clp(c.importe)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
